import { AlertCircle, Check, Loader2 } from 'lucide-react'

import type { components } from '@/api/schema'
import { parseUTCDate } from '@/lib/utils'

type ShopifyPrice = components['schemas']['ProductShopifyPriceRead']

function pushedLabel(pushedAt: string) {
  const date = parseUTCDate(pushedAt)
  const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  if (date.toDateString() === new Date().toDateString()) return time
  return `${date.toLocaleDateString([], { month: 'short', day: 'numeric' })}, ${time}`
}

/** Where the product's price stands on Shopify after a price edit (USA-1671). */
export function ShopifyPriceStatus({ shopifyPrice }: { shopifyPrice?: ShopifyPrice | null }) {
  if (!shopifyPrice) return null
  if (shopifyPrice.status === 'updating') {
    return (
      <span role="status" className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Updating Shopify…
      </span>
    )
  }
  if (shopifyPrice.status === 'failed') {
    return (
      <span role="status" className="flex items-center gap-1.5 text-xs text-destructive">
        <AlertCircle className="h-3.5 w-3.5" />
        Shopify update failed · retrying tonight
      </span>
    )
  }
  return (
    <span role="status" className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Check className="h-3.5 w-3.5 text-green-700 dark:text-green-500" />
      On Shopify{shopifyPrice.pushed_at ? ` · ${pushedLabel(shopifyPrice.pushed_at)}` : ''}
    </span>
  )
}
